<template>
  <el-drawer v-model="visible" size="100%" custom-class="work-electronic-drawer">
    <div ref="mapContainer" style="width:100%;height: 100%;"></div>
  </el-drawer>
</template>

<script>
import { getWorkProjectByProjectId } from "@/api/work";
import { defineComponent } from "vue";
export default defineComponent({
  emits: ["update:modelValue"],
  data(){
    return {
      map: null,
      project: {}
    }
  },
  props: {
    modelValue: Boolean,
    workAttendance: Object
  },
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    }
  },
  watch: {
    modelValue(val) {
      if (val) {
        this.clearMap();
        this.getProject();
        this.setMap();
      }
    }
  },
  methods: {
    getProject() {
      getWorkProjectByProjectId(this.workAttendance.projectId).then(({data}) => {
        this.project = data.data;
        this.setElectronicFence();
      });
    },
    setMap() { // 设置地图
      if (!this.$refs.mapContainer) {
         setTimeout(this.setMap, 50);
         return;
      }
      let center = this.workAttendance.clockGeographyData.split(',');
      if (!this.map) {
        this.map = new AMap.Map(this.$refs.mapContainer, {
          resizeEnable: true, // 允许缩放
          center // 设置地图的中心点
        });
      } else {
        this.map.setCenter(center);
      }

      let marker = new AMap.Marker({
        position: new AMap.LngLat(center[0], center[1])
      });
      this.map.add(marker);
    },
    setElectronicFence() { // 设置电子围栏
      if(this.project.electronicFence){
        let polygons = JSON.parse(this.project.electronicFence);
        if (polygons == null) return;
        for (let i = 0; i < polygons.length; i++) {
          this.map.add(new AMap.Polygon(polygons[i]));
        }
        this.map.setFitView()
      }
    },
    clearMap() {
      this.map && this.map.clearMap(); // 清除地图上的所有覆盖物
    }
  }
})
</script>

<style lang="scss" >
.work-electronic-drawer {
  .el-drawer__header{
    padding: 5px 10px 5px 10px;
    background: #d0d0d0;
    margin-bottom: 0px;
  }
  .el-drawer__body{
    padding: 0;
  }
}
</style>